// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__WJ-8D","sendOtp":"AuthorizeToLogin_sendOtp__1F0NU"};